const CATEGORY_ORDER = [
  'Pain & Discomfort',
  'Digestive Symptoms',
  'Female Health Symptoms',
  'Energy Levels',
  'Skin & Hair Symptoms',
  'Body Image Symptoms',
];

export function groupSymptomsByCategory<
  T extends { category: { name: string } | null },
>(symptoms: T[]) {
  const grouped: Record<string, T[]> = {};
  symptoms.forEach((symptom) => {
    if (!symptom.category) return;
    const categoryName = symptom.category.name;
    if (!grouped[categoryName]) {
      grouped[categoryName] = [];
    }
    grouped[categoryName].push(symptom);
  });

  const ordered: Record<string, T[]> = {};
  CATEGORY_ORDER.forEach((categoryName) => {
    if (grouped[categoryName]) {
      ordered[categoryName] = grouped[categoryName];
    }
  });

  Object.keys(grouped).forEach((categoryName) => {
    if (!ordered[categoryName]) {
      ordered[categoryName] = grouped[categoryName];
    }
  });

  return ordered;
}
